(function () {
  const root = document.querySelector("[data-pf-pdp]");
  if (!root || !window.PF_PDP) return;
  const data = window.PF_PDP;
  let variants = data.variants || [];
  const form = root.querySelector("[data-pf-form]");
  const idInput = root.querySelector("[data-pf-id]");
  const atc = root.querySelector("[data-pf-atc]");
  const atcLabel = atc.querySelector(".pf-atc__label");
  const atcTotal = atc.querySelector(".pf-atc__total");
  const errEl = root.querySelector("[data-pf-err]");
  const mainImg = root.querySelector("[data-pf-main]");

  const LEN_ORDER = ["Kurz", "Standard", "Lang", "Extra Lang", "Ultra Lang"];
  // Körpergröße par longueur (repris du guide Halara) : affiché dans la liste, la valeur reste le nom seul
  const LEN_CM = { "Kurz": "153–160 cm", "Standard": "160–170 cm", "Lang": "170–180 cm", "Extra Lang": "180–190 cm", "Ultra Lang": "190–200 cm" };
  const CS = (document.documentElement.lang || "").toLowerCase().startsWith("cs");
  const LEN_CS = {"Kurz":"Krátká","Standard":"Standardní","Lang":"Dlouhá","Extra Lang":"Extra dlouhá","Ultra Lang":"Ultra dlouhá"};
  const COL_CS = {"Schwarz":"Černá","Weiß":"Bílá"};
  function colorLabel(c) { return CS ? (COL_CS[c] || c) : c; }
  function lenLabel(l) { const name = CS ? (LEN_CS[l] || l) : l; return LEN_CM[l] ? name + " (" + LEN_CM[l] + ")" : name; }
  // Taille chiffrée EU (correspondance Halara) : affichée dans la liste, la valeur reste XS, M…
  const SIZE_EU = { "XXS": "30", "XS": "32/34", "S": "34/36", "M": "38/40", "L": "42/44", "XL": "46", "XXL": "48", "2X": "50/52", "3X": "54/56" };
  function sizeLabel(s) { return SIZE_EU[s] ? s + " (" + SIZE_EU[s] + ")" : s; }
  const SIZE_ORDER = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "1X", "2X", "3X"];
  const PF_COLORS = { "Deep Orchid": "#994c80", "Deep Aquamarine": "#535e56", "Forest Night": "#4a4734", "Candy Pink": "#d78c89", "Dusky Evening purple": "#5e4854", "Arctic": "#628589", "Oat Milk": "#d4cbbc", "Valiant Poppy": "#af2723", "Raspberry Rose": "#c63e7e", "Schwarz": "#2c2c2c", "Purple Sandalwood": "#765a61", "Royal Blue": "#3e4382", "Chocolate Martini": "#54443d", "Burro": "#906f5c", "Midnight Blue": "#282c37", "Egg Cream White": "#ded5ca", "Deep Red Grey": "#595651", "Autumn Chestnut": "#654437", "Rain Forest": "#13443e", "Red Mahogany": "#663741", "Cinnabar": "#924135", "Weiß": "#dbdde1", "Chive": "#495033", "Sepia": "#785d48", "Nebula Purple": "#816775", "Wood Thrush": "#9a743f", "Light Azure": "#638cac", "Primrose Pink": "#d6b2b6", "Baby Blue": "#a4b9bd", "Cloud Shore": "#c2d4db", "Silent Storm": "#757170", "Icelandic Blue": "#9d9cae", "Jacaranda": "#868cb1", "Atlantic Deep": "#38646d", "Buckskin": "#c38558" };
  function hexFor(c) { return PF_COLORS[c] || "#9a9488"; }
  function isLight(hex) {
    const h = hex.replace("#", "");
    return 0.299 * parseInt(h.slice(0, 2), 16) + 0.587 * parseInt(h.slice(2, 4), 16) + 0.114 * parseInt(h.slice(4, 6), 16) > 205;
  }
  function parseSize(raw) {
    const m = String(raw || "").match(/^(.+?)\s*\((.+)\)$/);
    return m ? { base: m[1].trim(), length: m[2].trim() } : { base: String(raw || "").trim(), length: "Standard" };
  }
  function sortBy(arr, order) { return order.filter((x) => arr.includes(x)).concat(arr.filter((x) => !order.includes(x))); }

  let colors = [], byColor = {}, lenByColor = {}, baseByCL = {}, variantMap = {};
  function buildIndexes() {
    variants.forEach((v) => {
      const p = parseSize(v.size); v._len = p.length; v._base = p.base;
      if (!byColor[v.color]) { byColor[v.color] = []; colors.push(v.color); }
      byColor[v.color].push(v);
      (lenByColor[v.color] = lenByColor[v.color] || []).includes(v._len) || lenByColor[v.color].push(v._len);
      const clk = v.color + "|" + v._len;
      (baseByCL[clk] = baseByCL[clk] || []).includes(v._base) || baseByCL[clk].push(v._base);
      variantMap[v.color + "|" + v._len + "|" + v._base] = v;
    });
    for (const c in lenByColor) lenByColor[c] = sortBy(lenByColor[c], LEN_ORDER);
    for (const k in baseByCL) baseByCL[k] = sortBy(baseByCL[k], SIZE_ORDER);
  }
  function lengthsForColor(c) { return lenByColor[c] || ["Standard"]; }
  function basesFor(c, l) { return baseByCL[c + "|" + l] || []; }
  function resolve(c, l, b) {
    return variantMap[c + "|" + l + "|" + b] ||
      (baseByCL[c + "|" + l] ? variantMap[c + "|" + l + "|" + baseByCL[c + "|" + l][0]] : null) ||
      (byColor[c] ? byColor[c][0] : null);
  }

  let state = { color: "", length: "Standard", base: "" };
  let tier = 1;

  function fillSelect(sel, opts, val, labelFn) {
    const frag = document.createDocumentFragment();
    opts.forEach((o) => {
      const op = document.createElement("option");
      op.value = o; op.textContent = labelFn ? labelFn(o) : o;
      if (o === val) op.selected = true;
      frag.appendChild(op);
    });
    sel.innerHTML = ""; sel.appendChild(frag);
  }
  // ---------- Galerie par couleur : les 6 photos de la couleur choisie ----------
  let colorImgs = {};
  const thumbsEl = root.querySelector("[data-pf-thumbs]");
  const colorsEl = root.querySelector("[data-pf-colors]");
  const colorNameEl = root.querySelector("[data-pf-colorname]");
  function sized(url, w) { return url ? url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w : url; }
  function imagesFor(color) {
    const list = colorImgs[color];
    if (list && list.length) return list;
    const v = byColor[color] && byColor[color][0];
    return v && v.image ? [v.image] : (data.media || []).slice(0, 1);
  }
  function showMain(src) { if (mainImg && src) { mainImg.src = src; mainImg.alt = (data.title || "") + " – " + state.color; } }
  function renderGallery(color) {
    const imgs = imagesFor(color);
    if (thumbsEl) {
      thumbsEl.innerHTML = "";
      imgs.forEach((u, k) => {
        const b = document.createElement("button"); b.type = "button"; b.className = "pf-thumb" + (k === 0 ? " is-active" : "");
        b.setAttribute("aria-label", (CS ? "Obrázek " : "Bild ") + (k + 1));
        const im = document.createElement("img"); im.src = sized(u, 160); im.alt = color + " " + (k + 1); im.width = 68; im.height = 85; im.loading = "lazy";
        b.appendChild(im);
        b.addEventListener("click", () => { thumbsEl.querySelectorAll(".pf-thumb").forEach((x) => x.classList.remove("is-active")); b.classList.add("is-active"); showMain(sized(u, 1400)); });
        thumbsEl.appendChild(b);
      });
      thumbsEl.scrollLeft = 0; thumbsEl.scrollTop = 0;
    }
    showMain(sized(imgs[0], 1400));
    // précharger les autres photos de la couleur
    imgs.slice(1).forEach((u) => { const p = new Image(); p.src = sized(u, 1400); });
  }
  function markColor(color) {
    if (colorNameEl) colorNameEl.textContent = colorLabel(color);
    if (colorsEl) colorsEl.querySelectorAll(".pf-cswatch").forEach((s) => { const on = s.dataset.color === color; s.classList.toggle("is-active", on); s.setAttribute("aria-checked", on ? "true" : "false"); });
  }
  function updateGallery(color) {
    state.color = color; markColor(color); renderGallery(color);
    const first = resolve(color, state.length, state.base);
    if (first && idInput) idInput.value = first.id;
  }
  function selectColor(color) {
    updateGallery(color);
    // appliquer la couleur à toutes les hosen du set actif
    root.querySelectorAll(".pf-btier.is-active .pf-item .pf-sel--color").forEach((sel) => {
      if (sel.value !== color && [...sel.options].some((o) => o.value === color)) { sel.value = color; sel.dispatchEvent(new Event("change")); }
    });
  }
  function buildSwatches() {
    if (!colorsEl) return;
    colorsEl.innerHTML = "";
    colors.forEach((c) => {
      const hx = hexFor(c);
      const s = document.createElement("button"); s.type = "button"; s.className = "pf-cswatch" + (isLight(hx) ? " pf-cswatch--light" : "");
      s.dataset.color = c; s.title = colorLabel(c); s.setAttribute("role", "radio"); s.setAttribute("aria-label", colorLabel(c));
      s.style.setProperty("--sw", hx);
      s.addEventListener("click", () => selectColor(c));
      colorsEl.appendChild(s);
    });
  }

  function buildItems(container, n) {
    container.innerHTML = "";
    for (let i = 1; i <= n; i++) {
      const row = document.createElement("div"); row.className = "pf-item";
      const head = document.createElement("div"); head.className = "pf-item__head";
      const lab = document.createElement("span"); lab.className = "pf-item__n"; lab.textContent = (CS ? "Kus " : "Hose ") + i;
      const dot = document.createElement("span"); dot.className = "pf-item__dot";
      head.appendChild(lab); head.appendChild(dot);

      const ctrls = document.createElement("div"); ctrls.className = "pf-item__ctrls";
      const cSel = document.createElement("select"); cSel.className = "pf-sel pf-sel--color"; cSel.setAttribute("aria-label", (CS ? "Barva " : "Farbe Hose ") + i);
      const lSel = document.createElement("select"); lSel.className = "pf-sel"; lSel.setAttribute("aria-label", (CS ? "Délka " : "Länge Hose ") + i);
      const sSel = document.createElement("select"); sSel.className = "pf-sel"; sSel.setAttribute("aria-label", (CS ? "Velikost " : "Größe Hose ") + i);
      fillSelect(cSel, colors, state.color, colorLabel);
      function setDot() { const hx = hexFor(cSel.value); dot.style.background = hx; dot.classList.toggle("pf-item__dot--light", isLight(hx)); }
      function refreshLen() { const lens = lengthsForColor(cSel.value); fillSelect(lSel, lens, lens.includes(state.length) ? state.length : lens[0], lenLabel); refreshSize(); }
      function refreshSize() { const bases = basesFor(cSel.value, lSel.value); fillSelect(sSel, bases, bases.includes(state.base) ? state.base : bases[0], sizeLabel); }
      cSel.addEventListener("change", () => { setDot(); refreshLen(); if (i === 1 && cSel.value !== state.color) updateGallery(cSel.value); });
      lSel.addEventListener("change", refreshSize);
      setDot(); refreshLen();
      ctrls.appendChild(cSel); ctrls.appendChild(lSel); ctrls.appendChild(sSel);
      row.appendChild(head); row.appendChild(ctrls);
      container.appendChild(row);
    }
  }

  function updateAtc() {
    const card = root.querySelector(".pf-btier.is-active");
    if (atcLabel) atcLabel.textContent = CS ? "Do košíku" : "In den Warenkorb";
    if (atcTotal) atcTotal.textContent = card ? card.getAttribute("data-total") : (CS ? "" : "39,95 €");
  }

  function setTier(n) {
    tier = n;
    root.querySelectorAll(".pf-btier").forEach((t) => {
      const on = Number(t.getAttribute("data-tier")) === n;
      t.classList.toggle("is-active", on);
      const head = t.querySelector(".pf-btier__head");
      if (head) head.setAttribute("aria-pressed", on ? "true" : "false");
      const items = t.querySelector("[data-items]");
      if (!items) return;
      if (on) buildItems(items, n); else items.innerHTML = "";
    });
    updateAtc();
  }

  root.querySelectorAll(".pf-btier__head").forEach((head) => {
    const n = Number(head.closest(".pf-btier").getAttribute("data-tier")) || 1;
    head.addEventListener("click", () => setTier(n));
    head.addEventListener("keydown", (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); setTier(n); } });
  });

  function openDrawer() {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent("variant:add", { bubbles: true, detail: {} }));
    if (typeof window.plCartOpen === "function") window.plCartOpen();
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (errEl) errEl.hidden = true;
    const active = root.querySelector(".pf-btier.is-active [data-items]");
    const items = {};
    if (active) active.querySelectorAll(".pf-item").forEach((row) => {
      const s = row.querySelectorAll("select");
      const v = resolve(s[0].value, s[1].value, s[2].value);
      if (v) items[v.id] = (items[v.id] || 0) + 1;
    });
    const payload = Object.keys(items).map((id) => ({ id: Number(id), quantity: items[id] }));
    if (!payload.length) { if (errEl) { errEl.textContent = CS ? "Vyberte variantu." : "Bitte Variante wählen."; errEl.hidden = false; } return; }
    atc.disabled = true;
    if (atcLabel) atcLabel.textContent = CS ? "Přidávám" : "Wird hinzugefügt"; if (atcTotal) atcTotal.textContent = "…";
    try {
      const cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      const res = await fetch(cartRoot + "cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: payload }),
      });
      if (!res.ok) throw new Error("add");
      openDrawer(); atc.disabled = false; updateAtc();
    } catch (err) {
      atc.disabled = false;
      if (atcLabel) atcLabel.textContent = CS ? "Zkusit znovu" : "Nochmal versuchen"; if (atcTotal) atcTotal.textContent = "";
    }
  });

  root.querySelectorAll("[data-thumb-src]").forEach((btn) => {
    btn.addEventListener("click", () => {
      root.querySelectorAll("[data-thumb-src]").forEach((x) => x.classList.remove("is-active"));
      btn.classList.add("is-active");
      const src = btn.getAttribute("data-thumb-src");
      if (mainImg && src) mainImg.src = src;
    });
  });

  // Tableau des tailles en fenêtre par-dessus la page
  const sizeLink = root.querySelector("[data-pf-sizelink]");
  const sizeModal = root.querySelector("[data-pf-sizemodal]");
  function closeModal() { if (sizeModal) { sizeModal.hidden = true; document.documentElement.classList.remove("pf-noscroll"); } }
  if (sizeLink && sizeModal) {
    sizeLink.addEventListener("click", () => {
      sizeModal.hidden = false;
      document.documentElement.classList.add("pf-noscroll");
      const c = sizeModal.querySelector("[data-pf-sizeclose]"); if (c) c.focus();
    });
    sizeModal.addEventListener("click", (e) => { if (e.target === sizeModal || e.target.closest("[data-pf-sizeclose]")) closeModal(); });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !sizeModal.hidden) closeModal(); });
  }

  function init() {
    if (!variants.length) return;
    colors = []; byColor = {}; lenByColor = {}; baseByCL = {}; variantMap = {};
    buildIndexes();
    const f = variants[0];
    state = { color: f.color, length: f._len, base: f._base };
    if (idInput) idInput.value = f.id;
    setTier(1);
    updateAtc();
    buildSwatches();
    updateGallery(state.color);
  }

  const jsonUrl = root.getAttribute("data-variants-url");
  const colorUrl = root.getAttribute("data-color-images-url");
  const pVariants = jsonUrl ? fetch(jsonUrl).then((r) => r.json()).then((all) => { if (Array.isArray(all) && all.length) variants = all; }).catch(() => {}) : Promise.resolve();
  const pColors = colorUrl ? fetch(colorUrl).then((r) => r.json()).then((m) => { if (m && typeof m === "object") colorImgs = m; }).catch(() => {}) : Promise.resolve();
  Promise.all([pVariants, pColors]).then(init);
})();
